export default "__VITE_ASSET__1dfd1886__"